import React from "react";

import {
    GaugeBackgroundArc,
    GaugeLabel,
    GaugeNationalPoint,
    GaugeRegionalArc,
    GaugeRegionalPoint,
    GaugeValue,
} from ".";

interface GaugeProps {
    id: string;
    regionalPercent: number;
    nationalPercent: number;
    label: string;
    reverseNegative?: boolean;
}

export const Gauge = (props: GaugeProps) => {
    const {
        id,
        regionalPercent,
        nationalPercent: statePercent,
        label,
        reverseNegative,
    } = props;

    const regionalValue = regionalPercent;
    const stateValue = statePercent;

    const getIsNegative = () =>
        !!reverseNegative
            ? regionalPercent > statePercent
            : regionalPercent < statePercent;

    return (
        <svg
            id={id}
            style={{ overflow: "visible", marginTop: 50 }}
            viewBox={[-1, -0.75, 2, 1].join(" ")}
        >
            <GaugeBackgroundArc />
            <GaugeRegionalArc
                id={id}
                value={regionalValue}
                isNegative={getIsNegative()}
            />
            <GaugeNationalPoint value={stateValue} />
            <GaugeRegionalPoint value={regionalValue} />
            <GaugeValue value={regionalPercent / 100} />
            <GaugeLabel label={label} />
        </svg>
    );
};
